import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const InformationStack = ({
  text,
  backgroundColor,
  textColor,
  variant,
  fontWeight,
  IconComponent,
  iconLast,
  sx,
  isClickable,
  className,
  ...props
}) => (
  <Stack
    direction={iconLast ? 'row-reverse' : 'row'}
    alignItems="center"
    spacing={1}
    className={className}
    sx={{
      width: 'fit-content',
      backgroundColor,
      px: 1,
      py: { xs: 0.25, sm: 0.5 },
      borderRadius: 4,
      cursor: isClickable ? 'pointer' : 'default',
      ...sx,
    }}
    {...props}
  >
    {IconComponent && IconComponent}
    <Typography variant={variant} color={textColor} sx={{ fontWeight }}>
      {text}
    </Typography>
  </Stack>
);

InformationStack.propTypes = {
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  variant: PropTypes.string,
  fontWeight: PropTypes.number,
  IconComponent: PropTypes.element,
  iconLast: PropTypes.bool,
  sx: PropTypes.shape({}),
  isClickable: PropTypes.bool,
  className: PropTypes.string,
};

InformationStack.defaultProps = {
  backgroundColor: 'primary.A100',
  textColor: 'text.primary',
  variant: 'body1',
  fontWeight: 500,
  IconComponent: undefined,
  iconLast: false,
  sx: {},
  isClickable: false,
  className: undefined,
};

export default InformationStack;
